import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css'],
   providers: [HelperService] 
})
export class RolesComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas:any=[];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;

  icon=this.helper.add_icon;
  icon_action='addClick';
  role_name='';
  role_id=0;
  role_perm:any=[];
  permissions;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});

  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router,private cookie:CookieService) {
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/roles',{ headers: this.headers })
    
    .subscribe(data => {
      this.datas = JSON.parse(data['_body']).roles;
       this.permissions = JSON.parse(data['_body']).permissions;
        this.dtTrigger.next();
     
    });
  }

  editClick(data){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.role_name=data.name;
    this.role_id=data.id;
    if(data.role_perm == undefined)
    {
      this.role_perm=[];
    }
    else
    {
      this.role_perm=data.role_perm;
    }
    
  
  }
  addClick(e){
    
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  add_form(addForm: NgForm){
  
  let body = new FormData();
  body.append('name', addForm.value.name);
 
   this.http.post(this.helper.base_url+'http/add/role', body,{ headers: this.headers })
   .subscribe(
     (res) => {
       let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Role added successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 update_form(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);
  //body.append('perm_id[]', addForm.value.perm_id);
  body.append('perm_id[]', this.role_perm);
 // console.log(addForm.value.perm_id);
   this.http.post(this.helper.base_url+'http/update/role/'+this.role_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Role updated successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 delete_form(id){
  let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/role/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) =>  {
            let body = JSON.parse(data['_body']);
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
          },
            //this.refresh(false,'Role Removed successfully')} , //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }
  refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/roles"]));
  
      
 }
 error_refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/roles"]));
  
      
 }


  permonchage(status,id)
  {
    if(status){
      this.role_perm.push(id);
    }else{
      let index = this.role_perm.indexOf(id);
 
    if (index > -1) {
       this.role_perm.splice(index, 1);
    }
   }
  
  }

}



// WEBPACK FOOTER //
// ./src/app/roles/roles.component.ts